import React from 'react';
import TermsCondition from '../components/termsCondition';

function termsCondition() {
    return <TermsCondition />;
}

export default termsCondition();
